<div class="loadingDiv" *ngIf="loading" >
  <div>
  </div>
</div>
